// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'truck';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M6.344 9V4.75H4.219A3.187 3.187 0 0 0 1.03 7.938v4.25a1.063 1.063 0 0 0 1.063 1.062h.531' />
    <path d='M16.969 10.063V4.75a1.063 1.063 0 0 0-1.063-1.063h-8.5A1.062 1.062 0 0 0 6.344 4.75V9M1.031 9h2.125A1.062 1.062 0 0 0 4.22 7.938V4.75m-.001 7.969a1.594 1.594 0 1 0 3.188 0 1.594 1.594 0 0 0-3.188 0zm8.5 0a1.592 1.592 0 0 0 2.72 1.127 1.596 1.596 0 0 0-.517-2.6 1.594 1.594 0 0 0-2.203 1.473zM9 13.25h2.125' />
  </g>
);

export const viewBox = '0 0 18 18';
